// // src/pages/admin/Agents/AdminAgents.jsx
// import React, { useState, useMemo, useEffect } from "react";
// import { useApp } from "../../../context/AppContext";
// import { useToast } from "../../../context/ToastContext";
// import {
//   generatePassword,
//   generateReferralCode,
// } from "../../../utils/authUtils";
// import { apiService } from "../../../services/api";
// import DataTable from "../../../components/DataTable/DataTable";
// import StatusBadge from "../../../components/StatusBadge/StatusBadge";
// import PageHeader from "../../../components/PageHeader/PageHeader";
// import Modal from "../../../components/Modal/Modal";
// import Button from "../../../components/Form/Button";
// import Input from "../../../components/Form/Input";
// import Select from "../../../components/Form/Select";
// import "./Agents.css";

// const AdminAgents = () => {
//   const { pumps } = useApp(); // don't reassign this variable
//   const { showToast } = useToast();
//   const [agents, setAgents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedAgent, setSelectedAgent] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isCredentialsModalOpen, setIsCredentialsModalOpen] = useState(false);
//   const [generatedCredentials, setGeneratedCredentials] = useState(null);

//   const [filters, setFilters] = useState({
//     search: "",
//     status: "",
//     city: "",
//   });

//   const [pagination, setPagination] = useState({
//     page: 1,
//     limit: 10,
//     total: 0,
//     totalPages: 1,
//   });

//   // ---- Fetch Agents ----
//   useEffect(() => {
//     const fetchAgents = async () => {
//       try {
//         setLoading(true);
//         const params = {
//           page: pagination.page,
//           limit: pagination.limit,
//           user_type: "agent",
//         };
//         const response = await apiService.getAgents(params);
//         const agnts = response?.data ?? response ?? [];
//         setAgents(Array.isArray(agnts) ? agnts : []);
//         setPagination((prev) => ({
//           ...prev,
//           total: response?.total ?? prev.total,
//           totalPages: response?.totalPages ?? prev.totalPages,
//         }));
//       } catch (error) {
//         console.error("Error fetching agents:", error);
//         showToast("Failed to load agents", "error");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAgents();
//   }, [showToast, pagination.page, pagination.limit]);

//   // ---- Cities list ----
//   const cities = useMemo(() => {
//     return [...new Set(agents.map((a) => a.city).filter(Boolean))].sort();
//   }, [agents]);

//   // ---- Form State ----
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     city: "",
//     referralCode: "",
//     status: "active",
//   });

//   // Normalize pumps safely
//   const pumpsList = useMemo(() => {
//     if (!pumps) return [];
//     if (Array.isArray(pumps)) return pumps;
//     if (pumps.data && Array.isArray(pumps.data)) return pumps.data;
//     return [];
//   }, [pumps]);

//   // ---- Filtering ----
//   const filteredAgents = useMemo(() => {
//     return agents.filter((agent) => {
//       if (filters.search) {
//         const searchLower = filters.search.toLowerCase();
//         if (
//           !agent.name?.toLowerCase()?.includes(searchLower) &&
//           !agent.email?.toLowerCase()?.includes(searchLower)
//         ) {
//           return false;
//         }
//       }

//       if (filters.status) {
//         const status = filters.status === "active";
//         if (typeof agent.is_active === "boolean") {
//           if (agent.is_active !== status) return false;
//         } else if (typeof agent.status === "string") {
//           if ((agent.status === "active") !== status) return false;
//         }
//       }

//       if (filters.city && agent.city !== filters.city) return false;

//       return true;
//     });
//   }, [agents, filters]);

//   // ---- Table Columns ----
//   const columns = [
//     {
//       key: "name",
//       label: "Name",
//     },
//     {
//       key: "email",
//       label: "Email",
//       render: (value) => value || "-",
//     },
//     {
//       key: "phone",
//       label: "Phone",
//     },
//     {
//       key: "city",
//       label: "City",
//     },
//     {
//       key: "referralCode",
//       label: "Referral Code",
//       render: (value) => (
//         <code className="referral-code-display">{value || "-"}</code>
//       ),
//     },
//     {
//       key: "is_active",
//       label: "Status",
//       render: (value) => (
//         <StatusBadge status={value ? "active" : "inactive"} type="user" />
//       ),
//     },
//     {
//       key: "actions",
//       label: "Actions",
//       sortable: false,
//       render: (value, row) => (
//         <div className="table-actions">
//           <Button
//             size="small"
//             variant="outline"
//             onClick={(e) => {
//               e.stopPropagation();
//               handleEdit(row);
//             }}
//           >
//             Edit
//           </Button>
//           <Button
//             size="small"
//             variant={row.is_active ? "outline" : "primary"}
//             onClick={(e) => {
//               e.stopPropagation();
//               handleToggleStatus(row);
//             }}
//           >
//             {row.is_active ? "Deactivate" : "Activate"}
//           </Button>
//         </div>
//       ),
//     },
//   ];

//   // ---- Handlers ----

//   const handleAdd = () => {
//     setFormData({
//       name: "",
//       email: "",
//       phone: "",
//       city: "",
//       referralCode: generateReferralCode(),
//       status: "active",
//     });
//     setSelectedAgent(null);
//     setIsModalOpen(true);
//   };

//   const handleEdit = (agent) => {
//     setFormData({
//       name: agent.name || "",
//       email: agent.email || "",
//       phone: agent.phone || "",
//       city: agent.city || "",
//       referralCode: agent.referralCode || generateReferralCode(),
//       status: agent.status ?? (agent.is_active ? "active" : "inactive"),
//     });
//     setSelectedAgent(agent);
//     setIsModalOpen(true);
//   };

//   const handleToggleStatus = async (agent) => {
//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       showToast("Authentication required. Please log in again.", "error");
//       window.location.href = "/login";
//       return;
//     }

//     try {
//       // ✅ Backend toggle call
//       await apiService.activateDeactivateUser(agent._id);

//       const newStatus = !agent.is_active;
//       showToast(
//         `Agent ${newStatus ? "activated" : "deactivated"} successfully`,
//         "success"
//       );

//       // ✅ Refresh agents list with agent filter
//       const params = {
//         page: pagination.page,
//         limit: pagination.limit,
//         user_type: "agent",
//       };
//       const response = await apiService.getAgents(params);
//       const agnts = response?.data ?? response ?? [];
//       setAgents(Array.isArray(agnts) ? agnts : []);
//     } catch (error) {
//       console.error("Error toggling agent status:", error);
//       if (error.response?.status === 401) {
//         showToast("Session expired. Please log in again.", "error");
//       } else {
//         showToast("Failed to update agent status", "error");
//       }
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       showToast("Authentication required. Please log in again.", "error");
//       window.location.href = "/login";
//       return;
//     }

//     try {
//       if (selectedAgent) {
//         // ✅ Edit existing agent via PUT /admin/user-listing/update-user/:userId
//         const updateData = {
//           name: formData.name,
//           phone: formData.phone,
//           city: formData.city,
//           is_active: formData.status === "active",
//         };
//         await apiService.updateUserAdmin(selectedAgent._id, updateData);
//         showToast("Agent updated successfully", "success");
//       } else {
//         // ✅ Add new agent via POST /admin/user-listing/add-users
//         const password = formData.password || generatePassword();

//         const userData = {
//           name: formData.name,
//           email: formData.email,
//           password,
//           user_type: "agent",
//           phone: formData.phone,
//           city: formData.city,
//         };

//         await apiService.addUser(userData);
//         showToast("Agent added successfully", "success");

//         // Show credentials modal
//         setGeneratedCredentials({
//           name: formData.name,
//           email: formData.email,
//           password,
//           referralCode: formData.referralCode || "",
//         });
//         setIsCredentialsModalOpen(true);
//       }

//       // ✅ Refresh agents list again
//       const params = {
//         page: pagination.page,
//         limit: pagination.limit,
//         user_type: "agent",
//       };
//       const response = await apiService.getAgents(params);
//       const agnts = response?.data ?? response ?? [];
//       setAgents(Array.isArray(agnts) ? agnts : []);

//       setIsModalOpen(false);
//       setSelectedAgent(null);
//     } catch (error) {
//       console.error("Error saving agent:", error);
//       if (error.response?.status === 401) {
//         showToast("Session expired. Please log in again.", "error");
//       } else {
//         showToast("Failed to save agent", "error");
//       }
//     }
//   };

//   return (
//     <div className="admin-agents">
//       <PageHeader
//         title="Agents"
//         actions={
//           <Button variant="primary" onClick={handleAdd}>
//             + Add Agent
//           </Button>
//         }
//       />

//       <div className="agents-filters">
//         <Input
//           label="Search by Name/Email"
//           placeholder="Search agents..."
//           value={filters.search}
//           onChange={(e) =>
//             setFilters({ ...filters, search: e.target.value })
//           }
//         />
//         <Select
//           label="Filter by Status"
//           value={filters.status}
//           onChange={(e) =>
//             setFilters({ ...filters, status: e.target.value })
//           }
//           options={[
//             { value: "", label: "All Status" },
//             { value: "active", label: "Active" },
//             { value: "inactive", label: "Inactive" },
//           ]}
//         />
//         <Select
//           label="Filter by City"
//           value={filters.city}
//           onChange={(e) =>
//             setFilters({ ...filters, city: e.target.value })
//           }
//           options={[
//             { value: "", label: "All Cities" },
//             ...cities.map((city) => ({ value: city, label: city })),
//           ]}
//         />
//       </div>

//       <DataTable
//         columns={columns}
//         data={filteredAgents}
//         searchable={false}
//         loading={loading}
//         pagination={pagination}
//         onPageChange={(page) =>
//           setPagination((prev) => ({ ...prev, page }))
//         }
//         onLimitChange={(limit) =>
//           setPagination((prev) => ({ ...prev, limit, page: 1 }))
//         }
//       />

//       {/* Add/Edit Modal */}
//       <Modal
//         isOpen={isModalOpen}
//         onClose={() => {
//           setIsModalOpen(false);
//           setSelectedAgent(null);
//         }}
//         title={selectedAgent ? "Edit Agent" : "Add New Agent"}
//         size="medium"
//       >
//         <form onSubmit={handleSubmit} className="agent-form">
//           <div className="form-row">
//             <Input
//               label="Name *"
//               value={formData.name}
//               onChange={(e) =>
//                 setFormData({ ...formData, name: e.target.value })
//               }
//               required
//             />
//             <Input
//               label="Email *"
//               type="email"
//               value={formData.email}
//               onChange={(e) =>
//                 setFormData({ ...formData, email: e.target.value })
//               }
//               required
//               disabled={!!selectedAgent}
//             />
//           </div>

//           <div className="form-row">
//             <Input
//               label="Phone"
//               value={formData.phone}
//               onChange={(e) =>
//                 setFormData({ ...formData, phone: e.target.value })
//               }
//             />
//             <Input
//               label="City"
//               value={formData.city}
//               onChange={(e) =>
//                 setFormData({ ...formData, city: e.target.value })
//               }
//             />
//           </div>

//           <div className="form-group">
//             <label className="form-label">Status</label>
//             <Select
//               value={formData.status}
//               onChange={(e) =>
//                 setFormData({ ...formData, status: e.target.value })
//               }
//               options={[
//                 { value: "active", label: "Active" },
//                 { value: "inactive", label: "Inactive" },
//               ]}
//             />
//           </div>

//           {!selectedAgent && (
//             <div className="info-note">
//               <p>
//                 💡 A random password and referral code will be generated and
//                 displayed after creation.
//               </p>
//             </div>
//           )}

//           <div className="modal-actions">
//             <Button
//               type="button"
//               variant="outline"
//               onClick={() => {
//                 setIsModalOpen(false);
//                 setSelectedAgent(null);
//               }}
//             >
//               Cancel
//             </Button>
//             <Button type="submit" variant="primary">
//               {selectedAgent ? "Update Agent" : "Create Agent"}
//             </Button>
//           </div>
//         </form>
//       </Modal>

//       {/* Credentials Display Modal */}
//       {/* <Modal
//         isOpen={isCredentialsModalOpen}
//         onClose={() => {
//           setIsCredentialsModalOpen(false);
//           setGeneratedCredentials(null);
//         }}
//         title="Agent Credentials"
//         size="small"
//       >
//         {generatedCredentials && (
//           <div className="credentials-display">
//             <p className="credentials-note">
//               ⚠️ <strong>Save these credentials!</strong> They won't be shown
//               again.
//             </p>
//             <div className="credentials-info">
//               <div className="credential-item">
//                 <label>Name:</label>
//                 <span>{generatedCredentials.name}</span>
//               </div>
//               <div className="credential-item">
//                 <label>Email:</label>
//                 <span>{generatedCredentials.email}</span>
//               </div>
//               <div className="credential-item">
//                 <label>Password:</label>
//                 <div className="password-display">
//                   <code>{generatedCredentials.password}</code>
//                   <Button
//                     size="small"
//                     variant="outline"
//                     onClick={() => {
//                       navigator.clipboard.writeText(
//                         generatedCredentials.password
//                       );
//                       showToast("Password copied to clipboard", "success");
//                     }}
//                   >
//                     Copy
//                   </Button>
//                 </div>
//               </div>
//               {generatedCredentials.referralCode && (
//                 <div className="credential-item">
//                   <label>Referral Code:</label>
//                   <div className="password-display">
//                     <code>{generatedCredentials.referralCode}</code>
//                     <Button
//                       size="small"
//                       variant="outline"
//                       onClick={() => {
//                         navigator.clipboard.writeText(
//                           generatedCredentials.referralCode
//                         );
//                         showToast(
//                           "Referral code copied to clipboard",
//                           "success"
//                         );
//                       }}
//                     >
//                       Copy
//                     </Button>
//                   </div>
//                 </div>
//               )}
//             </div>
//             <p className="credentials-instruction">
//               The agent can now log in at the login page using these credentials.
//             </p>
//             <div className="modal-actions">
//               <Button
//                 variant="primary"
//                 onClick={() => {
//                   setIsCredentialsModalOpen(false);
//                   setGeneratedCredentials(null);
//                 }}
//               >
//                 Got it
//               </Button>
//             </div>
//           </div>
//         )}
//       </Modal> */}
//     </div>
//   );
// };

// export default AdminAgents;

// src/pages/admin/Agents/AdminAgents.jsx
import React, { useState, useMemo, useEffect } from "react";
import { useApp } from "../../../context/AppContext";
import { useToast } from "../../../context/ToastContext";
import { generatePassword } from "../../../utils/authUtils";
import { apiService } from "../../../services/api";
import DataTable from "../../../components/DataTable/DataTable";
import StatusBadge from "../../../components/StatusBadge/StatusBadge";
import PageHeader from "../../../components/PageHeader/PageHeader";
import Modal from "../../../components/Modal/Modal";
import Button from "../../../components/Form/Button";
import Input from "../../../components/Form/Input";
import Select from "../../../components/Form/Select";
import "./Agents.css";

const AdminAgents = () => {
  const { pumps } = useApp();
  const { showToast } = useToast();

  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCredentialsModalOpen, setIsCredentialsModalOpen] = useState(false);
  const [generatedCredentials, setGeneratedCredentials] = useState(null);

  const [filters, setFilters] = useState({
    search: "",
    status: "",
    city: "",
  });

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 100000,
    total: 0,
    totalPages: 1,
  });

  // Fetch Agents
  useEffect(() => {
    const fetchAgents = async () => {
      try {
        setLoading(true);
        const params = {
          page: pagination.page,
          limit: pagination.limit,
          user_type: "agent",
        };
        const response = await apiService.getAgents(params);
        const agnts = response?.data ?? response ?? [];

        // setAgents(Array.isArray(agnts) ? agnts : []);

        const normalizedAgents = Array.isArray(agnts)
          ? agnts.map((agent) => ({
              ...agent,
              city: agent?.address?.locality || "", // <-- add city field
            }))
          : [];

        setAgents(normalizedAgents);

        setPagination((prev) => ({
          ...prev,
          total: response?.total ?? prev.total,
          totalPages: response?.totalPages ?? prev.totalPages,
        }));
      } catch (error) {
        console.error("Error fetching agents:", error);
        showToast("Failed to load agents", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchAgents();
  }, [pagination.page, pagination.limit, showToast]);

  // --- Cities ---
  const cities = useMemo(() => {
    return [
      ...new Set(agents.map((a) => a.address.locality).filter(Boolean)),
    ].sort();
  }, [agents]);

  console.log("city listing==========", cities);

  // --- Form State (no referral code) ---
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    status: "active",
  });

  // --- Filters ---
  const filteredAgents = useMemo(() => {
    return agents.filter((agent) => {
      if (filters.search) {
        const s = filters.search.toLowerCase();
        if (
          !agent.name?.toLowerCase()?.includes(s) &&
          !agent.email?.toLowerCase()?.includes(s)
        ) {
          return false;
        }
      }

      if (filters.status) {
        const active = filters.status === "active";
        if (agent.is_active !== active) return false;
      }

      if (filters.city && agent.city !== filters.city) return false;

      return true;
    });
  }, [agents, filters]);

  // --- Table Columns ---
  const columns = [
    { key: "name", label: "Name" },
    {
      key: "email",
      label: "Email",
      render: (value) => value || "-",
    },
    { key: "phone", label: "Phone" },
    { key: "city", label: "City" },

    // ✔ Referral code mapped from backend
    {
      key: "agent_referral_code",
      label: "Referral Code",
      render: (value) => (
        <code className="referral-code-display">{value || "-"}</code>
      ),
    },

    {
      key: "is_active",
      label: "Status",
      render: (value) => (
        <StatusBadge status={value ? "active" : "inactive"} type="user" />
      ),
    },
    {
      key: "actions",
      label: "Actions",
      sortable: false,
      render: (value, row) => (
        <div className="table-actions">
          <Button
            size="small"
            variant="outline"
            onClick={(e) => {
              e.stopPropagation();
              handleEdit(row);
            }}
          >
            Edit
          </Button>
          <Button
            size="small"
            variant={row.is_active ? "outline" : "primary"}
            onClick={(e) => {
              e.stopPropagation();
              handleToggleStatus(row);
            }}
          >
            {row.is_active ? "Deactivate" : "Activate"}
          </Button>
        </div>
      ),
    },
  ];

  // ---- Handlers ----

  const handleAdd = () => {
    setFormData({
      name: "",
      email: "",
      phone: "",
      city: "",
      status: "active",
    });
    setSelectedAgent(null);
    setIsModalOpen(true);
  };

  const handleEdit = (agent) => {
    setFormData({
      name: agent.name || "",
      email: agent.email || "",
      phone: agent.phone || "",
      city: agent.city || "",
      status: agent.is_active ? "active" : "inactive",
    });
    setSelectedAgent(agent);
    setIsModalOpen(true);
  };

  const handleToggleStatus = async (agent) => {
    try {
      await apiService.activateDeactivateUser(agent._id);

      showToast(
        `Agent ${agent.is_active ? "deactivated" : "activated"} successfully`,
        "success"
      );

      const params = {
        page: pagination.page,
        limit: pagination.limit,
        user_type: "agent",
      };
      const response = await apiService.getAgents(params);
      setAgents(response?.data ?? []);
    } catch (error) {
      console.error("Error toggling status:", error);
      showToast("Failed to update agent status", "error");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (selectedAgent) {
        // Update agent
        await apiService.updateUserAdmin(selectedAgent._id, {
          name: formData.name,
          phone: formData.phone,
          city: formData.city,
          is_active: formData.status === "active",
        });

        showToast("Agent updated successfully", "success");
      } else {
        // Create new agent (NO referral code)
        const password = generatePassword();

        await apiService.addUser({
          name: formData.name,
          email: formData.email,
          password,
          phone: formData.phone,
          city: formData.city,
          user_type: "agent",
        });

        showToast("Agent added successfully", "success");

        // Credentials modal
        setGeneratedCredentials({
          name: formData.name,
          email: formData.email,
          password,
        });
        setIsCredentialsModalOpen(true);
      }

      // Refresh after save
      const params = {
        page: pagination.page,
        limit: pagination.limit,
        user_type: "agent",
      };
      const response = await apiService.getAgents(params);
      setAgents(response?.data ?? []);

      setIsModalOpen(false);
      setSelectedAgent(null);
    } catch (error) {
      console.error("Error saving agent:", error);
      showToast("Failed to save agent", "error");
    }
  };

  return (
    <div className="admin-agents">
      <PageHeader
        title="Agents"
        actions={
          <Button variant="primary" onClick={handleAdd}>
            + Add Agent
          </Button>
        }
      />

      <div className="agents-filters">
        <Input
          label="Search by Name/Email"
          placeholder="Search agents..."
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />
        <Select
          label="Filter by Status"
          value={filters.status}
          onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          options={[
            { value: "", label: "All Status" },
            { value: "active", label: "Active" },
            { value: "inactive", label: "Inactive" },
          ]}
        />
        <Select
          label="Filter by City"
          value={filters.city}
          onChange={(e) => setFilters({ ...filters, city: e.target.value })}
          options={[
            { value: "", label: "All Cities" },
            ...cities.map((city) => ({ value: city, label: city })),
          ]}
        />
      </div>

      <DataTable
        columns={columns}
        data={filteredAgents}
        searchable={false}
        loading={loading}
        pagination={pagination}
        onPageChange={(page) => setPagination((prev) => ({ ...prev, page }))}
        onLimitChange={(limit) =>
          setPagination((prev) => ({ ...prev, limit, page: 1 }))
        }
      />

      {/* Add/Edit Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedAgent(null);
        }}
        title={selectedAgent ? "Edit Agent" : "Add New Agent"}
        size="medium"
      >
        <form onSubmit={handleSubmit} className="agent-form">
          <div className="form-row">
            <Input
              label="Name *"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              required
            />
            <Input
              label="Email *"
              type="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              required
              disabled={!!selectedAgent}
            />
          </div>

          <div className="form-row">
            <Input
              label="Phone"
              value={formData.phone}
              onChange={(e) =>
                setFormData({ ...formData, phone: e.target.value })
              }
            />
            <Input
              label="City"
              value={formData.city}
              onChange={(e) =>
                setFormData({ ...formData, city: e.target.value })
              }
            />
          </div>

          <div className="form-group">
            <label className="form-label">Status</label>
            <Select
              value={formData.status}
              onChange={(e) =>
                setFormData({ ...formData, status: e.target.value })
              }
              options={[
                { value: "active", label: "Active" },
                { value: "inactive", label: "Inactive" },
              ]}
            />
          </div>

          {!selectedAgent && (
            <div className="info-note">
              <p>
                💡 A random password will be generated and shown after creation.
              </p>
            </div>
          )}

          <div className="modal-actions">
            <Button
              type="button"
              variant="outline"
              onClick={() => {
                setIsModalOpen(false);
                setSelectedAgent(null);
              }}
            >
              Cancel
            </Button>
            <Button type="submit" variant="primary">
              {selectedAgent ? "Update Agent" : "Create Agent"}
            </Button>
          </div>
        </form>
      </Modal>

      {/* Credentials Modal */}
      <Modal
        isOpen={isCredentialsModalOpen}
        onClose={() => {
          setIsCredentialsModalOpen(false);
          setGeneratedCredentials(null);
        }}
        title="Agent Credentials"
        size="small"
      >
        {generatedCredentials && (
          <div className="credentials-display">
            <p className="credentials-note">
              ⚠️ <strong>Save these credentials!</strong> They won’t be shown
              again.
            </p>

            <div className="credentials-info">
              <div className="credential-item">
                <label>Name:</label>
                <span>{generatedCredentials.name}</span>
              </div>

              <div className="credential-item">
                <label>Email:</label>
                <span>{generatedCredentials.email}</span>
              </div>

              <div className="credential-item">
                <label>Password:</label>
                <div className="password-display">
                  <code>{generatedCredentials.password}</code>
                  <Button
                    size="small"
                    variant="outline"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        generatedCredentials.password
                      );
                      showToast("Password copied", "success");
                    }}
                  >
                    Copy
                  </Button>
                </div>
              </div>
            </div>

            <div className="modal-actions">
              <Button
                variant="primary"
                onClick={() => {
                  setIsCredentialsModalOpen(false);
                  setGeneratedCredentials(null);
                }}
              >
                Got it
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default AdminAgents;
